// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pay-container[data-v-40e89110] {\n  min-height: 100vh;\n  background: white;\n}\n.pay-loading[data-v-40e89110] {\n  font-size: 0;\n}\n.pay-loading img[data-v-40e89110] {\n  padding-top: 1.28rem;\n  width: 3.22667rem;\n  height: 3.2rem;\n}\n.pay-loading p[data-v-40e89110] {\n  padding: 0.77333rem 0 1.28rem;\n  font-size: 0.48rem;\n  color: #333333;\n}", ""]);
// Exports
module.exports = exports;
